import BoletimSection from "../BoletimSection/BoletimSection";
import BoletimSubsection from "../BoletimSubsection/BoletimSubsection";

import styles from "./DesafioPratico.module.css";
import RadarGraph from "./RadarGraph/RadarGraph";

function DesafioPratico({ group, challenge, challenges_grades }) {
    return (
        <BoletimSection
            title={"Desafio Prático"}
            icon={"medal"}
        >
            <BoletimSubsection subtitle={`Competências do ${challenge}`}>
                <div className={styles.chartContainer}>
                    <RadarGraph data={challenges_grades} group={group} />
                </div>

                <div className={styles.gradesTableContainer}>
                    <div
                        key={`desafio-pratico-header`}
                        className={[styles.row, styles.header].join(" ")}
                        style={{ gridTemplateColumns: "2fr repeat(2, 1fr)" }}
                    >
                        <div className={styles.td}>Competência</div>
                        <div className={styles.td}>Média do Grupo ({group})</div>
                        <div className={styles.td}>Média da Turma</div>
                    </div>
                    {challenges_grades.length > 0  && challenges_grades.sort((a, b) => {
                        var f_a = Number((a.skill.split('.')[0]).replace('C', ''));
                        var f_b = Number((b.skill.split('.')[0]).replace('C', ''));
                        
                        return f_a - f_b;
                    }).map(
                        (
                            {
                                skill,
                                grade,
                                class_grade,
                            },
                            i
                        ) => {
                            const rowStyles =
                                i % 2 === 1
                                    ? styles.row
                                    : [styles.row, styles.dark].join(" ");
                            return (
                                <div
                                    key={`desafio-pratico-grade-${i}`}
                                    className={rowStyles}
                                    style={{ gridTemplateColumns: "2fr repeat(2, 1fr)" }}
                                >
                                    <div
                                        className={[styles.td, styles.subject].join(
                                            " "
                                        )}
                                    >
                                        {skill}
                                    </div>
                                    <div className={styles.td}>
                                        {Number(grade).toFixed(2)}
                                    </div>
                                    <div className={styles.td}>
                                        {class_grade.toFixed(2)}
                                    </div>
                                </div>
                            );
                        }
                    )}
                </div>
            </BoletimSubsection>
        </BoletimSection>
    );
}

export default DesafioPratico;
